var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0046 11.579C38.0056 14.314 42.1875 20.4554 42.1875 27.593C42.1875 37.2753 34.4924 45.1243 25 45.1243C15.5076 45.1243 7.8125 37.2753 7.8125 27.593C7.8125 22.8924 9.62622 18.6239 12.5788 15.4759C14.1756 17.7505 16.2927 19.6193 18.7525 20.9014C18.8465 15.0031 21.5583 9.75394 25.7544 6.31006C27.3449 8.48553 29.4539 10.3137 32.0046 11.579Z",
    stroke: "#90CC61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 38.7501C29.3147 38.7501 32.8125 35.1824 32.8125 30.7814C32.8125 26.7369 29.8584 23.3961 26.031 22.8814C23.9303 24.8036 22.4712 27.4405 22.0215 30.4172C20.391 30.0107 18.886 29.2779 17.5767 28.2906C17.3241 29.0742 17.1875 29.9115 17.1875 30.7814C17.1875 35.1824 20.6853 38.7501 25 38.7501Z",
    stroke: "#90CC61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.f3b956d810625f9a0b51cad988c05385.svg";
export { ForwardRef as ReactComponent };